import { render, staticRenderFns } from "./userauthitem.vue?vue&type=template&id=0c91d90d&scoped=true&"
import script from "./userauthitem.vue?vue&type=script&lang=js&"
export * from "./userauthitem.vue?vue&type=script&lang=js&"
import style0 from "./userauthitem.vue?vue&type=style&index=0&id=0c91d90d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c91d90d",
  null
  
)

export default component.exports